<template>
  <div class="mv_detail">
    <breadcrumb :titleList="titleList"></breadcrumb>
    <div class="mv_detail-wrap">
      <div class="mv_detail-contain">
        <page-title :title="movieClient.munitName">
          <span slot="left"
                :style="{color:movieClient.downState?'#39B54A':'#D44052'}">【{{movieClient.downState?'开机':'已停机'}}】</span>
          <div>
            <el-switch :value="downState"
                       active-text="开机"
                       inactive-text="停机"
                       @change="changeDownState"></el-switch>
          </div>
        </page-title>
        <detail-card :title="'基本信息'">
          <div class="mv_detail-row_wrap">
            <el-row>
              <el-col :span="4">所在省：{{movieClient.providName}}</el-col>
              <el-col :span="4">类别：{{movieClient.className}}</el-col>
              <el-col :span="4">级别：{{movieClient.categoryName}}</el-col>
              <el-col :span="4">客户号：{{movieClient.mclientno}}</el-col>
              <el-col :span="8">地址：{{movieClient.maddress}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">卡号：{{movieClient.mcardno}}</el-col>
              <el-col :span="4">邮编：{{movieClient.mpostcode}}</el-col>
              <el-col :span="4">旧卡号：{{movieClient.moldno}}</el-col>
              <el-col :span="12">机器号：{{movieClient.mmacno}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">实际终端数：{{movieClient.mroom}}</el-col>
              <el-col :span="4">首次开机日：{{movieClient.modate?movieClient.modate.split('T')[0]:''}}</el-col>
              <el-col :span="4">停机日：{{movieClient.mcdate?movieClient.mcdate.split('T')[0]:''}}</el-col>
              <el-col :span="12">停机原因：{{movieClient.mcreason}}</el-col>
            </el-row>
            <el-row>备注：{{movieClient.mcontent}}</el-row>
            <el-row>
              <el-col :span="15">创建者/日期：{{movieClient.createName}}/{{movieClient.createTime?movieClient.createTime.split('T')[0]:""}}</el-col>
              <el-col :span="9">最近修改：{{movieClient.updateName}}/{{movieClient.updateTime?movieClient.updateTime.split('T')[0]:""}}</el-col>
            </el-row>
          </div>
          <div>
            <el-button @click="editMovieClientForm">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'pencil-alt']" />编辑
            </el-button>
          </div>
        </detail-card>
        <detail-card :title="'最新合同信息'">
          <span v-if="movieContract.length"
                slot="left"
                :style="{color:movieContract[0].contractStatus!=='合同过期'?'#39B54A':'#D44052'}">【{{movieContract[0].contractStatus}}】</span>
          <div v-if="movieContract.length"
               class="mv_detail-row_wrap">
            <el-row>
              <el-col :span="9">合同ID：{{movieContract[0].cpId}}</el-col>
              <el-col :span="9">合同起日：{{movieContract[0].cpStarttime?movieContract[0].cpStarttime.split('T')[0]:""}}</el-col>
              <el-col :span="6">合同止日：{{movieContract[0].cpStoptime?movieContract[0].cpStoptime.split('T')[0]:""}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">平台：{{movieContract[0].platName}}</el-col>
              <el-col :span="9">合同类型：{{movieContract[0].typeName}}</el-col>
              <el-col :span="6">签约终端：{{movieContract[0].cpSignedevice}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">合同金额：{{movieContract[0].cpContractmoney}}</el-col>
              <el-col :span="9">经手人：{{movieContract[0].cpPerson}}</el-col>
              <el-col :span="6">代理商：{{movieContract[0].dealerName}}</el-col>
            </el-row>
            <el-row>备注：{{movieContract[0].cpMemo}}</el-row>
            <el-row>
              <el-col :span="15">创建者/日期：{{movieContract[0].createName}}/{{movieContract[0].createTime?movieContract[0].createTime.split('T')[0]:""}}</el-col>
              <el-col :span="9">最近修改：{{movieContract[0].updateName}}/{{movieContract[0].updateTime?movieContract[0].updateTime.split('T')[0]:""}}</el-col>
            </el-row>
          </div>
          <div class="mv_detail-history">
            <div @click="contractHistory=!contractHistory"
                 class="mv_detail-history_title">签约历史
              <font-awesome-icon v-if="!contractHistory"
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-down']" />
              <font-awesome-icon v-else
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-up']" />
            </div>
            <table v-show="contractHistory">
              <tr>
                <th>合同Id</th>
                <th>合同起日</th>
                <th>合同止日</th>
                <th>平台</th>
                <th>合同类型</th>
                <th>签约终端</th>
                <th>合同金额</th>
                <th>到款金额</th>
                <th style="width:150px;">操作</th>
              </tr>
              <tr v-for="(item,index) in movieContract"
                  :key="item.cpId">
                <td>{{item.cpId}}</td>
                <td>{{item.cpStarttime.split('T')[0]}}</td>
                <td>{{item.cpStoptime.split('T')[0]}}</td>
                <td>{{item. platName}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.cpSignedevice}}</td>
                <td>{{item.cpContractmoney}}</td>
                <td>{{item.arrivalMoneyTotal}}</td>
                <td style="width:150px;display:flex;justify-content:space-between">
                  <a @click="addCompactmoneyForm(index)">添加到款</a>
                  <a @click="editMovieContractForm(index)">编辑</a>
                  <a @click="delMovieContract(item.cpId)">删除</a>
                </td>
              </tr>
            </table>
          </div>
          <div>
            <el-button @click="editMovieContractForm('add')">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'plus']" />新建合同
            </el-button>
            <el-button v-if="movieContract.length"
                       @click="editMovieContractForm('copy')">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'copy']" />复制合同
            </el-button>
          </div>
        </detail-card>
        <detail-card :title="'最新合同到款'">
          <span v-if="movieCompactmoney.length"
                slot="left"
                :style="{color:movieContract[0].contractToStatus==='全部到款'?'#39B54A':'#D44052'}">【{{movieContract[0].contractToStatus}}】</span>
          <div v-if="movieCompactmoney.length"
               class="mv_detail-row_wrap">
            <el-row>合同ID：{{movieCompactmoney[0].cpId}}</el-row>
            <el-row>
              <el-col :span="9">款项起日：{{movieCompactmoney[0].starttime?movieCompactmoney[0].starttime.split('T')[0]:''}}</el-col>
              <el-col :span="9">款项止日：{{movieCompactmoney[0].stoptime?movieCompactmoney[0].stoptime.split('T')[0]:''}}</el-col>
              <el-col :span="6">到款日期：{{movieCompactmoney[0].datetime?movieCompactmoney[0].datetime.split('T')[0]:''}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">代理商到款：{{movieCompactmoney[0].ctvpayment}}</el-col>
              <el-col :span="9">凤凰到款：{{movieCompactmoney[0].phoenixpayment}}</el-col>
            </el-row>
            <el-row>代理商：{{movieContract[0].dealerName}}</el-row>
            <el-row>备注：{{movieCompactmoney[0].memo}}</el-row>
            <el-row>
              <el-col :span="15">创建者/日期：{{movieCompactmoney[0].createName}}/{{movieCompactmoney[0].createTime?movieClient.createTime.split('T')[0]:""}}</el-col>
              <el-col :span="9">最近修改：{{movieCompactmoney[0].updateName}}/{{movieCompactmoney[0].updateTime?movieClient.updateTime.split('T')[0]:""}}</el-col>
            </el-row>
          </div>
          <div class="mv_detail-history">
            <div @click="moneyHistory=!moneyHistory"
                 class="mv_detail-history_title">到款历史
              <font-awesome-icon v-if="!moneyHistory"
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-down']" />
              <font-awesome-icon v-else
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-up']" />
            </div>
            <table v-show="moneyHistory">
              <tr>
                <th>合同Id</th>
                <th>款项起日</th>
                <th>款项止日</th>
                <th>到款日期</th>
                <th>代理商到款</th>
                <th>凤凰到款</th>
                <th style="width:70px;">操作</th>
              </tr>
              <tr v-for="(item,index) in movieCompactmoney"
                  :key="item.id">
                <td>{{item.cpId}}</td>
                <td>{{item.starttime.split('T')[0]}}</td>
                <td>{{item.stoptime.split('T')[0]}}</td>
                <td>{{item.datetime.split('T')[0]}}</td>
                <td>{{item.ctvpayment}}</td>
                <td>{{item.phoenixpayment}}</td>
                <td style="width:70px;display:flex;justify-content:space-between">
                  <a @click="editCompactmoney(index)">编辑</a>
                  <a @click="delCompactmoney(item.id)">删除</a>
                </td>
              </tr>
            </table>
          </div>
        </detail-card>
        <detail-card :title="'联系人'">
          <div @click="editContact(-1)"
               class="mv_detail-add"
               slot="right">
            <font-awesome-icon style="color:#39B54A; margin-right:10px;"
                               :icon="['fas', 'plus-circle']" />添加联系人
          </div>
          <table class="mv_detail-contact">
            <tr>
              <th>姓名</th>
              <th>职位</th>
              <th>手机</th>
              <th>座机</th>
              <th>地址</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in contact"
                :key="item.cid">
              <td>{{item.cname}}</td>
              <td>{{item.cposition}}</td>
              <td>{{item.cphoen}}</td>
              <td>{{item.ctel}}</td>
              <td>{{item.caddress}}</td>
              <td style="cursor:pointer; color:#F0722B"
                  @click="editContact(index)">编辑</td>
            </tr>
          </table>
        </detail-card>
      </div>
    </div>
    <!--编辑基本信息-->
    <el-dialog class="mv_detail-dialog"
               title="基本信息"
               :visible.sync="movieClientFormShow">
      <el-form label-position="top"
               class="mv_detail-form">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="单位">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.munitName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="省份">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mprovid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="类别">
              <el-select clearable
                         placeholder="请选择"
                         @change="formTypeChange"
                         v-model="movieClientForm.classId">
                <el-option v-for="(item,index) in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="级别">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mcategory">
                <el-option v-for="item in categoryList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="卡号">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mcardno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input clearable
                        v-model="movieClientForm.maddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="客户号">
              <el-input clearable
                        v-model="movieClientForm.mclientno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="终端数">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mroom"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机器号">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mmacno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮编">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mpostcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="关机原因">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mcreason"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="旧卡号">
              <el-input clearable
                        v-model="movieClientForm.moldno"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="首次开机日期">
              <el-date-picker v-model="movieClientForm.modate"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关机日期">
              <el-date-picker v-model="movieClientForm.mcdate"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <div class="mv_detail-title">开机授权信息</div>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="起始日期">
              <el-date-picker v-model="movieClientForm.mstartTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终止日期">
              <el-date-picker v-model="movieClientForm.mstopTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="平台">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mplatform">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mtype">
                <el-option v-for="item in accrediTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签约终端">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.msignedevice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同金额">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mcontractmoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="经手人">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieClientForm.mperson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="代理商">
              <el-select clearable
                         v-model="movieClientForm.mdealerId">
                <el-option v-for="item in agentList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="5"
                      v-model="movieClientForm.mcontent"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitEditMovieClient()">提 交</el-button>
        <el-button @click="movieClientFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--合同信息-->
    <el-dialog class="mv_detail-dialog"
               title="合同信息"
               v-if='movieContractFormShow'
               :visible.sync="movieContractFormShow">
      <el-form label-position="top"
               :model="movieContractForm"
               ref="movieContractForm"
               :rules="movieContractRules"
               class="mv_detail-form">
        <el-row>
          <el-form-item label="单位">
            <el-input disabled
                      :value="movieClient.munitName"></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item prop="cpStarttime"
                          label="起始日期">
              <el-date-picker :disabled="movieContractOption==='edit'"
                              v-model="movieContractForm.cpStarttime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="cpStoptime"
                          label="终止日期">
              <el-date-picker :disabled="movieContractOption==='edit'"
                              v-model="movieContractForm.cpStoptime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="平台">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieContractForm.cpPlat">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="类型">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieContractForm.cpType">
                <el-option v-for="item in accrediTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签约终端">
              <el-input clearable
                        @input="cpSignedeviceChange"
                        placeholder="请输入"
                        v-model="movieContractForm.cpSignedevice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="cpContractmoney"
                          label="合同金额">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieContractForm.cpContractmoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="经手人">
              <el-input clearable
                        placeholder="请输入"
                        v-model="movieContractForm.cpPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="代理商">
              <el-select clearable
                         v-model="movieContractForm.cpDealerId">
                <el-option v-for="item in agentList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="5"
                      v-model="movieContractForm.cpMemo"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitMovieContract()">提 交</el-button>
        <el-button @click="movieContractFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 合同到款信息 -->
    <el-dialog v-if="movieContract.length&&movieCompactmoneyFormShow"
               class="mv_detail-dialog"
               title="合同到款信息"
               :visible.sync="movieCompactmoneyFormShow">
      <el-form label-position="top"
               :model="movieCompactmoneyForm"
               ref="movieCompactmoneyForm"
               class="mv_detail-form"
               :rules="movieCompactmoneyRules">
        <el-row>
          <el-form-item label="单位">
            <el-input disabled
                      :value="movieClient.munitName"></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="合同起日">
              <el-date-picker disabled
                              v-model="movieContract[editMoneyIndex].cpStarttime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同止日">
              <el-date-picker disabled
                              v-model="movieContract[editMoneyIndex].cpStoptime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同平台">
              <el-select disabled
                         placeholder="请选择"
                         v-model="movieContract[editMoneyIndex].cpPlat">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="合同类型">
              <el-select disabled
                         placeholder="请选择"
                         v-model="movieContract[editMoneyIndex].cpType">
                <el-option v-for="item in accrediTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签约终端">
              <el-input placeholder="请输入"
                        disabled
                        v-model="movieContract[editMoneyIndex].cpSignedevice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同金额">
              <el-input placeholder="请输入"
                        disabled
                        v-model="movieContract[editMoneyIndex].cpContractmoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="欠款">
              <el-input placeholder="请输入"
                        disabled
                        v-model="movieContract[editMoneyIndex].arrearages"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款期至">
              <el-input disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item prop="starttime"
                          label="款项起日">
              <el-date-picker v-model="movieCompactmoneyForm.starttime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="stoptime"
                          label="款项止日">
              <el-date-picker v-model="movieCompactmoneyForm.stoptime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="datetime" label="到款日期">
              <el-date-picker v-model="movieCompactmoneyForm.datetime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="代理商到款">
              <el-input placeholder="请输入"
                        @input="ctvpaymentChange"
                        v-model="movieCompactmoneyForm.ctvpayment"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="凤凰到款">
              <el-input placeholder="请输入"
                        v-model="movieCompactmoneyForm.phoenixpayment"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="5"
                      v-model="movieCompactmoneyForm.memo"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitMovieCompactmoneyForm()">提 交</el-button>
        <el-button @click="movieCompactmoneyFormShow=false">取 消</el-button>
      </div>
    </el-dialog>
    <!--电影台关闭弹窗-->
    <el-dialog class="mv_detail-downstate_dialog"
               title="关机选项"
               :visible.sync="downStateFormShow">
      <el-row>
        <el-date-picker v-model="downStateForm.closeTime"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
      </el-row>
      <el-row>
        <el-input type="textarea"
                  :rows="5"
                  v-model="downStateForm.closeReason"></el-input>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="closeMovie()">确 认</el-button>
        <el-button @click="downStateFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--联系人信息-->
    <el-dialog class="mv_detail-dialog"
               title="联系人信息"
               :visible.sync="contactFormShow">
      <el-form label-position="top"
               class="mv_detail-form">
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input clearable
                        v-model="contactForm.cname"
                        placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="性别">
              <el-select v-model="contactForm.csex"
                         placeholder="请选择">
                <el-option label="男"
                           :value="0"></el-option>
                <el-option label="女"
                           :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="年龄">
              <el-input clearable
                        placeholder="请输入"
                        v-model="contactForm.cage"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        v-model="contactForm.cposition"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="手机">
              <el-input clearable
                        placeholder="请输入"
                        v-model="contactForm.cphoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="固话">
              <el-input clearable
                        placeholder="请输入"
                        v-model="contactForm.ctel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input placeholder="请输入"
                        v-model="contactForm.cfax"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="区号">
              <el-input placeholder="请输入"
                        v-model="contactForm.czonecode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮编">
              <el-input placeholder="请输入"
                        v-model="contactForm.czipcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="微信">
              <el-input clearable
                        placeholder="请输入"
                        v-model="contactForm.cqm"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="地址">
            <el-input clearable
                      placeholder="请输入"
                      v-model="contactForm.caddress"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="简历">
            <el-input type="textarea"
                      :rows="5"
                      v-model="contactForm.cresume"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitContact()">提 交</el-button>
        <el-button @click="contactFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from '@/servies/axios'
import api from '@/servies/api'
import pageTitle from '@/components/pageTitle'
import breadcrumb from '@/components/breadcrumb'
import detailCard from '@/components/detailCard'
import moment from 'moment'
export default {
  components: {
    pageTitle,
    breadcrumb,
    detailCard
  },
  data() {
    var validateStartTime = (rule, value, callback) => {
      if (!value && this.movieCompactmoneyFormShow) {
        callback('款项起日不可为空')
      } else {
        callback()
      }
    }
    var validateDateTime = (rule, value, callback) => {
      if (!value && this.movieCompactmoneyFormShow) {
        callback('到款日期不可为空')
      } else {
        callback()
      }
    }
    var validateStopTime = (rule, value, callback) => {
      if (!value) {
        callback('款项止日不可为空')
      } else if (
        !moment(this.movieCompactmoneyForm.starttime).isBefore(value) &&
        this.movieCompactmoneyFormShow
      ) {
        callback('款项止日应在款项起日之后')
      } else {
        callback()
      }
    }
    var validateCpStopTime = (rule, value, callback) => {
      if (!value) {
        callback('终止日期不可为空')
      } else if (
        !moment(this.movieContractForm.cpStarttime).isBefore(value) &&
        this.movieContractFormShow
      ) {
        callback('终止日期应在起始日期之后')
      } else {
        callback()
      }
    }
    var validateCpStartTime = (rule, value, callback) => {
      if (!value && this.movieContractFormShow) {
        callback('起始日期不可为空')
      } else {
        callback()
      }
    }
    var validateStartTime = (rule, value, callback) => {
      if (!value  && this.movieCompactmoneyFormShow) {
        callback('款项起日不可为空')
      } else {
        callback()
      }
    }
    var validateCpContractmoney = (rule, value, callback) => {
      if (value === '' && this.movieCompactmoneyFormShow) {
        callback('请输入合同金额')
      } else if (value <= 0 && this.movieCompactmoneyFormShow) {
        callback('合同金额不可小于或等于0')
      } else {
        callback()
      }
    }
    return {
      from: '',
      titleList: [],
      id: '',
      movieClient: '',
      movieContract: '',
      movieCompactmoney: '',
      contact: '',
      downState: '',

      typeList: [],
      categoryList: [],
      providList: [],
      platformList: [],
      accrediTypeList: [],
      agentList: [],

      downStateFormShow: false,
      downStateForm: {
        closeTime: '',
        closeReason: ''
      },

      contactFormShow: false,
      contactAdd: false,
      contactForm: {
        cname: '',
        csex: '',
        cposition: '',
        cage: '',
        cphoen: '',
        ctel: '',
        czonecode: '',
        czipcode: '',
        cqm: '',
        caddress: '',
        cfax: '',
        cresume: '',
        ctype: 0
      },
      movieContractOption: '',
      contractHistory: false,
      movieContractFormShow: false,
      movieContractForm: {
        cpStarttime: '',
        cpStoptime: '',
        cpPlat: '',
        cpType: '',
        cpSignedevice: '',
        cpContractmoney: '',
        cpPerson: '',
        cpDealerId: '',
        cpMemo: ''
      },
      movieContractRules: {
        cpStarttime: [{ validator: validateCpStartTime, trigger: 'change' }],
        cpStoptime: [{ validator: validateCpStopTime, trigger: 'change' }],
        cpContractmoney: [
          { validator: validateCpContractmoney, trigger: 'blur' }
        ]
      },
      movieClientFormShow: false,
      movieClientForm: {
        munitName: '',
        mprovid: '',
        mcategory: '',
        mcardno: '',
        classId: '',
        maddress: '',
        mclientno: '',
        mroom: '',
        mmacno: '',
        mpostcode: '',
        mcreason: '',
        moldno: '',
        modate: '',
        mcdate: '',
        mstartTime: '',
        mstopTime: '',
        mplatform: '',
        mtype: '',
        msignedevice: '',
        mcontractmoney: '',
        mperson: '',
        mdealerId: '',
        mcontent: '',
        mid: ''
      },
      moneyHistory: false,
      movieCompactmoneyFormShow: false,
      movieCompactmoneyForm: {
        cpId: '',
        ctId: '',
        starttime: '',
        stoptime: '',
        datetime: '',
        ctvpayment: '',
        phoenixpayment: '',
        dealerId: '',
        memo: ''
      },
      editMoneyIndex: 0,
      movieCompactmoneyRules: {
        starttime: [{ validator: validateStartTime, trigger: 'change' }],
        stoptime: [{ validator: validateStopTime, trigger: 'change' }],
        datetime:[{validator:validateDateTime,trigger:'change'}],
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.fullPath
    })
  },
  created() {
    this.id = this.$route.params.id
    this.getDetail()
    this.getSelectList()
  },
  methods: {
    getDetail() {
      // 获取详情
      axios
        .get(api.movieClientDetails + `?id=${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取电影台客户详情成功', res.data.result)
            this.movieClient = res.data.result.movieClient[0]
            this.downState = !!this.movieClient.downState
            this.movieContract = res.data.result.movieContract || []

            this.movieCompactmoney = res.data.result.movieCompactmoney || []
            this.contact = res.data.result.contact
            this.setTitleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },

    setTitleList() {
      if (this.$route.query.agent) {
        this.titleList = [
          { name: '凤凰管理系统', src: '/home' },
          { name: '代理商管理', src: '/mv_channel/agent' },
          { name: this.$route.query.agent, src: this.from },
          { name: this.movieClient.munitName }
        ]
      } else {
        this.titleList = [
          { name: '凤凰管理系统', src: '/home' },
          { name: '电影台业务', src: '/mv_channel/bussiness' },
          { name: this.movieClient.munitName }
        ]
      }
    },
    //添加单位Form的下拉框
    getSelectList() {
      Promise.all([
        //获取平台
        axios.get(api.getPlatformTypeList).then(res => {
          if (res.data.code === 0) {
            console.log('获取平台成功', res.data.result)
            this.platformList = res.data.result
          } else {
            console.log('获取平台失败', res.data.msg)
          }
        }),
        //获取电影台类别
        axios.get(api.clientCategory).then(res => {
          if (res.data.code === 0) {
            console.log('获取类型--级别列表成功', res.data.result)
            this.typeList = res.data.result
          } else {
            console.log('获取类型--级别列表失败', res.data.msg)
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        }),
        //获取合同类型
        axios.get(api.getAccrediTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取合同类型成功', res.data.result)
            this.accrediTypeList = res.data.result
          } else {
            console.log('获取合同类型失败', res.data.msg)
          }
        }),
        //获取代理商
        axios.get(api.getagent).then(res => {
          if (res.data.code === 0) {
            console.log('获取代理商列表成功', res.data.result)
            this.agentList = res.data.result
          } else {
            console.log('获取代理商列表失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    //编辑基本信息
    editMovieClientForm() {
      this.movieClientForm = _.pick(
        this.movieClient,
        _.keys(this.movieClientForm)
      )
      for (let i in this.typeList) {
        if (this.typeList[i].id === this.movieClientForm.classId) {
          this.movieClientForm.classId = Number(i)
          this.categoryList = this.typeList[i].children
          break
        }
      }
      this.movieClientFormShow = true
    },
    formTypeChange() {
      this.movieClientForm.mcategory = ''
      let index = this.movieClientForm.classId
      this.categoryList = this.typeList[index].children
    },
    //提交基本信息
    submitEditMovieClient() {
      let params = _.cloneDeep(this.movieClientForm)
      params.classId = this.typeList[this.movieClientForm.classId].id
      axios
        .post(api.updateMovieClient, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '修改基本信息成功',
              type: 'success'
            })
            this.movieClientFormShow = false
            this.getDetail()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //编辑合同信息
    editMovieContractForm(option) {
      if (option === 'add') {
        this.movieContractOption = 'add'
        this.movieContractForm = {
          cpStarttime: '',
          cpStoptime: '',
          cpPlat: '',
          cpType: '',
          cpSignedevice: 110,
          cpContractmoney: 18480,
          cpPerson: '',
          cpDealerId: '',
          cpMemo: ''
        }
      } else if (option === 'copy') {
        this.movieContractOption = 'copy'
        this.movieContractForm = _.pick(
          this.movieContract[0],
          _.keys(this.movieContractForm)
        )
        console.log(this.movieContract[0])
        this.movieContractForm.cpStoptime = moment(
          this.movieContract[0].cpStoptime
        )
          .add(1, 'y')
          .format('YYYY-MM-DD')
        this.movieContractForm.cpStarttime = moment(
          this.movieContract[0].cpStarttime
        )
          .add(1, 'y')
          .format('YYYY-MM-DD')
      } else {
        this.movieContractOption = 'edit'
        this.movieContractForm = _.pick(
          this.movieContract[option],
          _.keys(this.movieContractForm)
        )
        this.movieContractForm.cpId = this.movieContract[option].cpId
      }
      this.movieContractFormShow = true
    },
    //提交合同信息
    submitMovieContract() {
      this.$refs.movieContractForm.validate(valid => {
        if (valid) {
          let params = _.cloneDeep(this.movieContractForm)
          params.mid = this.id
          if (this.movieContractOption !== 'edit') {
            axios
              .post(api.addMovieContract, params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '添加合同信息成功',
                    type: 'success'
                  })
                  this.movieContractFormShow = false
                  this.getDetail()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(error => {
                this.$message.error('网络错误，稍后重试')
              })
          } else {
            axios
              .post(api.updateMovieContract, params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '修改合同信息成功',
                    type: 'success'
                  })
                  this.movieContractFormShow = false
                  this.getDetail()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(error => {
                this.$message.error('网络错误，稍后重试')
              })
          }
        } else {
          return false
        }
      })
    },
    //删除合同信息
    delMovieContract(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        axios
          .get(api.deleteContract + `?id=${id}`)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '删除合同信息成功',
                type: 'success'
              })
              this.getDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      })
    },
    //添加合同到款信息
    addCompactmoneyForm(index) {
      this.editMoneyIndex = index
      this.movieCompactmoneyForm = {
        cpId: this.movieContract[index].cpId,
        ctId: this.id,
        starttime: this.movieContract[index].cpStarttime,
        stoptime: this.movieContract[index].cpStoptime,
        datetime: '',
        ctvpayment: this.movieContract[index].arrearages,
        phoenixpayment: '',
        dealerId: '',
        memo: ''
      }
      this.ctvpaymentChange(this.movieCompactmoneyForm.ctvpayment)
      this.movieCompactmoneyFormShow = true
    },
    //中视到款改变凤凰到款
    ctvpaymentChange(v) {
      if (this.movieContract[0].platName === '亚太六') {
        this.movieCompactmoneyForm.phoenixpayment = v * 0.8
      } else {
        this.movieCompactmoneyForm.phoenixpayment = v
      }
    },
    //终端改变金额
    cpSignedeviceChange(v) {
      if (v >= 110) {
        this.movieContractForm.cpContractmoney = (v - 110) * 168 + 18480
      }
    },
    //提交合同到款信息
    submitMovieCompactmoneyForm() {
      this.$refs.movieCompactmoneyForm.validate(valid => {
        if (valid) {
          let params = _.cloneDeep(this.movieCompactmoneyForm)
          if (params.id) {
            axios
              .post(api.updateMovieCompactmoney, params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '编辑合同到款信息成功',
                    type: 'success'
                  })
                  this.movieCompactmoneyFormShow = false
                  this.getDetail()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(error => {
                this.$message.error('网络错误，稍后重试')
              })
          } else {
            axios
              .post(api.addMovieCompactmoney, params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '添加合同到款信息成功',
                    type: 'success'
                  })
                  this.movieCompactmoneyFormShow = false
                  this.getDetail()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(error => {
                this.$message.error('网络错误，稍后重试')
              })
          }
        } else {
          return false
        }
      })
    },
    //编辑合同到款信息
    editCompactmoney(index) {
      for (let i in this.movieContract) {
        if (this.movieContract[i].cpId === this.movieCompactmoney[index].cpId) {
          this.editMoneyIndex = i
          break
        }
      }
      this.movieCompactmoneyForm = _.pick(
        this.movieCompactmoney[index],
        _.keys(this.movieCompactmoneyForm)
      )
      this.movieCompactmoneyForm.id = this.movieCompactmoney[index].id
      this.movieCompactmoneyFormShow = true
    },
    //删除合同到款信息
    delCompactmoney(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        axios
          .get(api.deleteCompactmoney + `?id=${id}`)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '删除合同到款信息成功',
                type: 'success'
              })
              this.getDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      })
    },
    //编辑联系人
    editContact(index) {
      if (index !== -1) {
        this.contactAdd = false
        this.contactForm = _.pick(this.contact[index], _.keys(this.contactForm))
        this.contactForm.cid = this.contact[index].cid
      } else {
        this.contactAdd = true
        this.contactForm = {
          cname: '',
          csex: '',
          cposition: '',
          cage: '',
          cphoen: '',
          ctel: '',
          czonecode: '',
          czipcode: '',
          cqm: '',
          caddress: '',
          cfax: '',
          cresume: '',
          ctype: 0
        }
      }
      this.contactFormShow = true
    },
    //提交联系人
    submitContact() {
      let params = _.cloneDeep(this.contactForm)
      params.mid = this.id
      if (!this.contactAdd) {
        //修改联系人
        axios
          .post(api.updateContacts, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改联系人信息成功',
                type: 'success'
              })
              this.contactFormShow = false
              this.getDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      } else {
        //添加联系人
        axios
          .post(api.addContacts, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '添加联系人成功',
                type: 'success'
              })
              this.contactFormShow = false
              this.getDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      }
    },
    //关机或开机切换
    changeDownState(v) {
      if (v) {
        this.$confirm('确认开机？', '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            axios
              .post(api.openmovie + `?id=${this.movieContract[0].mid}`)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '电影台开机成功',
                    type: 'success'
                  })
                  this.downState = true
                  this.getDetail()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(error => {
                this.$message.error('网络错误，稍后重试')
              })
          })
          .catch(() => {})
      } else {
        this.downStateFormShow = true
      }
    },
    //关机
    closeMovie() {
      this.downStateForm.id = this.movieContract[0].mid
      axios
        .post(api.closemovie, this.downStateForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '电影台关机成功',
              type: 'success'
            })
            this.downStateFormShow = false
            this.getDetail()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>


<style lang="scss">
.mv_detail {
  .mv_detail-wrap {
    padding: 77px 30px 0px 30px;
    .mv_detail-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .mv_detail-row_wrap {
        margin-bottom: 19px;
      }
      .mv_detail-add {
        cursor: pointer;
      }
      .mv_detail-contact {
        tr {
          th {
            height: 34px;
            background: #6e6e6e;
            color: #fff;
          }
          td {
            text-align: center;
            height: 37px;
          }
        }
      }
      .mv_detail-history {
        border: 1px dashed rgba(220, 223, 230, 1);
        padding: 14px 19px 0px 19px;
        margin-bottom: 29px;
        .mv_detail-history_title {
          margin-bottom: 12px;
          cursor: pointer;
        }
        th {
          height: 31px;
          background: #f0f0f0;
          &:nth-child(1) {
            padding-left: 15px;
            text-align: left;
          }
        }
        tr {
          td {
            border-bottom: 1px solid rgba(220, 223, 230, 1);
            padding: 15px;
            text-align: center;
            background: #fff;
            a {
              cursor: pointer;
              color: #f0722b;
            }
            &:nth-child(1) {
              text-align: left;
            }
          }
          &:nth-last-child(1) {
            td {
              border: none;
            }
          }
        }
      }
      .el-row {
        padding: 13px 20px;
        &:nth-child(odd) {
          background: #f1f5f9;
        }
        &:nth-child(even) {
          background: #ffffff;
        }
      }
    }
  }
  .mv_detail-downstate_dialog {
    .el-row {
      margin-bottom: 20px;
    }
    .el-dialog__body {
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      text-align: left;
    }
  }
  .mv_detail-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }
    .mv_detail-form {
      .mv_detail-title {
        margin-bottom: 20px;
        color: #4a4a4a;
        font-weight: 600;
        font-size: 18px;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .mv_detail-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
